export function length(value, modifiers) {
  return {
    valid: !value || (modifiers && modifiers.length && parseInt(modifiers[0]) === value.length),
    errorMessage: 'Bitte geben Sie genau ' + modifiers[0] + ' Zeichen ein.',
  }
}
